import apiClient from "@/services/axios";
import moment from "moment";
import JsPDF from "jspdf";
import { Modal } from "ant-design-vue";

let {
  fixArabicParentheses,
  totalPtsTreshold,
  studentCount,
  bulletinfOnTwoPages,
  bulletinColors,
  fuseSubSubjects,
  waitLoadingImage,
  getLogoWidth,
  loadImage,
  roundRect,
  rgbToHex,
  getCertificationNameByMoyenne,
} = require("./common");
const drawModuleHeaderMondial = function (doc, ctx, startY, title) {
  // module title
  let x = 65;
  let y = 63 + startY;
  let width = 125;
  doc.setFillColor(0xff, 0xff, 0xff);
  doc.setDrawColor(0xff, 0xff, 0xff);
  //doc.rect(x, y + 20, width + 10, 10, "FD");

  // module header shapes
  x = 95;
  y = 72.6 + startY;
  width = 109;
  doc.setFillColor(...bulletinColors.color2);
  // المادة rect
  roundRect(ctx, x, y, width, 7.5, {}, true, true);

  x = 139 - 60;
  y = 72.6 + startY;
  width = 16;
  doc.setFillColor(...bulletinColors.color6);
  roundRect(ctx, x, y, width, 7.4, {}, true, true);

  doc.setLineWidth(0.4);
  doc.setFillColor(...bulletinColors.color6);
  doc.setDrawColor(...bulletinColors.color2);
  doc.rect(124 - 60, 72.3 + startY, 15, 8, "FD");
  doc.rect(86 - 60, 72.3 + startY, 38, 8, "FD");
  doc.rect(65 - 60, 72.3 + startY, 10, 8, "FD");
  doc.rect(75 - 60, 72.3 + startY, 10, 8, "FD");

  // doc.line(155 - 60, 80.3 + startY, 202.5, 80.3 + startY);

  // Add new rectangle for "Module"
  x = 202.5 - 60;
  y = 72.3 + startY;
  width = 25;
  let height = 8;
  doc.setFillColor(...bulletinColors.color2);
  doc.setDrawColor(...bulletinColors.color2);
  // doc.rect(x, y, width, height, "FD");

  // Add text "Module" inside the new rectangle
  doc.setFont("Amiri", "Bold");
  doc.setFontSize(13);
  doc.setTextColor(0xff, 0xff, 0xff);
  let text = "المجال";
  let textWidth = doc.getTextWidth(text);
  doc.text(text, 171, y + height - 2);

  doc.setFont("Amiri", "Bold");
  text = "المادة";
  width = doc.getTextWidth(text);
  doc.text(text, 179 - 60, 78 + startY);

  text = "العدد / 20";
  doc.setFontSize(9);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 141 - 60, 78 + startY);

  text = "معدل\nالمجال";
  doc.setFontSize(9);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 132 - 60, 75.2 + startY, "center");

  text = "توصيّات المدّرس";
  doc.setFontSize(11);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 94 - 60, 77.5 + startY);

  text = "أعلى\nعدد بالقسم";
  doc.setFontSize(6);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 80 - 60, 75 + startY, { align: "center" });

  text = "أدنى\nعدد بالقسم";
  doc.setFontSize(6);
  doc.setTextColor(...bulletinColors.color2);
  width = doc.getTextWidth(text);
  doc.text(text, 70 - 60, 75 + startY, { align: "center" });
};

const drawBulletinMondial = async function (
  doc,
  ctx,
  bulletinData,
  affichageBulletin,
  stampImage,
  config
) {
  const {
    selectedLevel,
    schoolDetails,
    selectedClassName,
    schoolarYearName,
    certifs,
    selectedTrimester,
  } = config;
  bulletinColors = {
    color1: [70, 187, 239],
    color2: [64, 187, 239],
    color3: [16, 169, 229],
    color4: [67, 62, 63],
    color5: [52, 172, 215],
    color6: [224, 237, 243],
    color7: [64, 187, 239],
    color8: [225, 225, 226],
    color9: [224, 237, 243],
  };

  const pdf_width = doc.internal.pageSize.width;
  let width = 0;
  let width2 = 0;

  // ending header line
  doc.setDrawColor(...bulletinColors.color5);
  doc.setLineWidth(0.8);
  doc.line(0, 40 - 18, pdf_width, 40 - 18);

  // trimester rounded rect title
  doc.setDrawColor(...bulletinColors.color5);
  doc.setLineWidth(0.4);
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(pdf_width / 2 - 25, 34 - 18, 48, 12, 4, 4, "FD");

  // trimester text
  doc.setFontSize(16);
  doc.setFont("Amiri", "normal");
  doc.setTextColor(...bulletinColors.color5);
  let title = "";
  switch (selectedTrimester) {
    case "1":
      title = "الثلاثي الأول";
      break;
    case "2":
      title = "الثلاثي الثاني";
      break;
    case "3":
      title = "الثلاثي الثالث";
      break;
  }
  doc.setFont("Noto Sans Arabic", "Bold");
  width = doc.getTextWidth(title);
  doc.text(title, pdf_width / 2 - width / 2, 41.2 - 18);

  const className = selectedClassName;
  const student = bulletinData;

  let studentLabel =
    bulletinData.gender === "male" ? " : التلميذ" : " : التلميذة";

  // student name
  doc.setFont("Amiri", "normal");
  doc.setFontSize(12);

  doc.setTextColor(0, 0, 0);

  let schoolTypeText =
    selectedLevel <= 9 ? " المدرسة الابتدائيّة " : "  المعهد الخاص ";
  text = schoolDetails.ArabicName
    ? schoolTypeText + schoolDetails.ArabicName
    : "................................................... : المدرسة الابتدائيّة";
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width - width - 12, 8);
  text = ` ${schoolarYearName}  : السنة الدراسيّة`;
  width = doc.getTextWidth(text);
  doc.text(text, 10, 8);

  let text = studentLabel;
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width - width - 12, 14.5);

  text = student.fullName;
  doc.setFont("Amiri", "normal");
  doc.setFontSize(13);
  width2 = doc.getTextWidth(text);
  doc.text(text, pdf_width - width - width2 - 12, 14.5);
  doc.setFont("Amiri", "normal");
  doc.setFontSize(12);
  // student classroom
  text = " : القسم";
  doc.setTextColor(0, 0, 0);
  width = doc.getTextWidth(text);
  width2 = doc.getTextWidth(className);
  doc.text(text, 13 + width2, 14.5);

  doc.text(className, 12, 14.5);
  // number of students in classroom
  if (affichageBulletin.headers.nbInscription) {
    text = String(
      Array.isArray(bulletinData.students)
        ? bulletinData.students.length
        : bulletinData.students
    );
    width2 = doc.getTextWidth(text);
    doc.text(text, 12, 20);
    text = " : عدد التلاميذ المرسّمين";
    width = doc.getTextWidth(text);
    doc.text(text, 12 + width2, 20);
  }

  // identUnique
  if (affichageBulletin.headers.identUnique && student.uniqueId) {
    text = " : المعرف الوحيد";
    width = doc.getTextWidth(text);
    doc.text(text, pdf_width - width - 12, 20);
    text = String(student.uniqueId);
    width2 = doc.getTextWidth(text);
    doc.text(text, pdf_width - width2 - width - 12, 20);
  }
  const cellToDelete = {};
  let topMargin = -41;
  let tableSize = 9;
  switch (selectedLevel) {
    case 1:
      tableSize = 11.5;
      break;
    case 2:
      tableSize = 11.5;
      break;
    case 3:
      tableSize = 10.5;
      break;
    case 4:
      tableSize = 9.5;
      break;
    default:
      break;
  }

  student.modules.forEach((m) => {
    //try {
    let arr = [];
    let array = [];

    drawModuleHeaderMondial(doc, ctx, topMargin, m.name);
    topMargin += 17.2;
    let formattedModuName = m.name;
    if (m.name.length > 23 && m.name.indexOf(" و ") != -1) {
      let indexOfFirst = m.name.indexOf(" و ");
      formattedModuName =
        m.name.slice(0, indexOfFirst) + "\n" + m.name.slice(indexOfFirst);
    }
    let moduleSpan = 0;
    m.subjects.forEach((c) => {
      moduleSpan +=
        c.subSubjectMarks && c.subSubjectMarks.length > 0
          ? c.subSubjectMarks.length
          : 1;
    });
    // Module Area
    arr[9] = {
      content: formattedModuName,
      rowSpan: moduleSpan,
      colSpan: 1,
      styles: {
        halign: "right",
        valign: "middle",
        cellPadding: {
          right: 1,
          left: 1,
        },
        fillColor: rgbToHex(...bulletinColors.color7),
        fontSize: 10,
        textColor: "#ffffff",
        lineColor: [229, 229, 229],
      },
    };
    m.subjects.forEach((c) => {
      let subFormattedName = c.name;
      if (c.name.length > 50 && c.name.indexOf(" و ") != -1) {
        let indexOfFirst = c.name.indexOf(" و ");
        subFormattedName =
          c.name.slice(0, indexOfFirst) + "\n" + c.name.slice(indexOfFirst);
      }

      const spanNumber =
        c.subSubjectMarks && c.subSubjectMarks.length > 0
          ? c.subSubjectMarks.length
          : 1;
      const colspan =
        spanNumber == 1
          ? c.subSubjectMarks && c.subSubjectMarks.length > 0
            ? 1
            : 3
          : 1;
      //const lines = subFormattedName.split("\n");
      // Get the maximum length
      //const maxLength = Math.max(...lines.map((line) => line.length));
      const lines = subFormattedName.split("\n");
      //Get the maximum length
      const maxLength = Math.max(...lines.map((line) => line.length));
      let subjectFontSize = maxLength >= 12 ? tableSize * 0.8 : tableSize + 1;

      //ﺍﻟﻤﺎﺩﺓ

      arr[8] = {
        content: subFormattedName,
        rowSpan: spanNumber,
        colSpan: colspan,
        styles: {
          halign: "right",
          valign: "middle",

          fillColor: rgbToHex(...bulletinColors.color7),
          fontSize: subjectFontSize,
          textColor: "#ffffff",
          lineColor: [229, 229, 229],
          cellPadding: {
            top: 0.8,
            bottom: 0.8,
            right: 2,
            left: 1,
          },
        },
      };
      // ﺍﻟﻌﺪﺩ / 20
      arr[5] = {
        content: c.mark ?? "--",
        rowSpan: spanNumber,
        styles: {
          halign: "center",
          valign: "middle",
          fontSize: 10,
          lineColor: [...bulletinColors.color5],
        },
      };

      arr[4] = cellToDelete;
      arr[3] = cellToDelete;
      arr[2] = cellToDelete;

      //best mark
      arr[1] = {
        content: c.max,
        rowSpan: spanNumber,
        styles: {
          halign: "center",
          valign: "middle",
          fontSize: 9,
          cellPadding: 0,
          lineColor: [...bulletinColors.color5],
        },
      };

      //lowest mark
      arr[0] = {
        content: c.min,
        rowSpan: spanNumber,
        styles: {
          halign: "center",
          valign: "middle",
          fontSize: 9,
          cellPadding: 0,
          lineColor: [...bulletinColors.color5],
        },
      };
      //sub subjects
      if (c.subSubjectMarks)
        c.subSubjectMarks.forEach((subs) => {
          try {
            arr[6] = {
              content: subs.mark ?? "--",
              styles: {
                halign: "center",
                valign: "middle",
                cellPadding: 0,
                fontSize: 8,
                fillColor: rgbToHex(...bulletinColors.color9),
                textColor: rgbToHex(...bulletinColors.color2),
                lineColor: bulletinColors.color2,
              },
            };

            arr[7] = {
              content: `${subs.name} (/${subs.maxMark})`,
              styles: {
                halign: "right",
                valign: "middle",
                fontSize: 7,
                fillColor: rgbToHex(...bulletinColors.color9),
                textColor: rgbToHex(...bulletinColors.color2),
                lineColor: bulletinColors.color2,
              },
            };
            array.push(arr);
            arr = [];
          } catch (error) {
            console.error("error sub", error);
          }
        });
      else array.push(arr);
      arr = [];
    });

    //end shifting

    array[0][2] = {
      content: "",
      rowSpan: array.length,
      styles: {
        lineColor: [...bulletinColors.color5],
      },
    };
    //appreciation

    if (
      (m.appreciation && m.appreciation.length > 0) ||
      !m.submodules ||
      m.submodules.every((submodule) => submodule.NbSubjects === 0)
    ) {
      array[0][3] = {
        content: m.appreciation
          ? fixArabicParentheses(m.appreciation.trim())
          : "",
        rowSpan: array.length,
        styles: {
          halign: "center",
          valign: "middle",
          fontSize: m.appreciation?.length > 15 ? 10 : 12,
          lineColor: [...bulletinColors.color5],
          cellPadding: 1,
        },
      };
    } else {
      let appIndex = 0;
      m.submodules.forEach((subModule) => {
        const subSubjectCount = m.subjects
          .filter((subject) => subject.submoduleID === subModule._id)
          .reduce(
            (acc, subject) =>
              acc +
              (subject.subSubjectMarks ? subject.subSubjectMarks.length : 1),
            0
          );
        let rowNumber = subSubjectCount;
        array[appIndex][3] = {
          content: subModule.appreciation.trim(),
          rowSpan: rowNumber,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 10,
            lineColor: [52, 172, 215],
            cellPadding: 1,
          },
        };
        appIndex += rowNumber;
      });
    }
    //ﻣﻌﺪﻝ ﺍﻟﻤﺠﺎﻝ
    array[0][4] = {
      content: m.moyenne,
      rowSpan: array.length,
      styles: {
        halign: "center",
        fontSize: 12,
        valign: "middle",
        lineColor: [...bulletinColors.color5],
      },
    };

    for (let row = 0; row < array.length; row++) {
      array[row] = array[row].filter((cell) => cell !== cellToDelete);
    }
    doc.autoTable({
      startY: 64 + topMargin,
      theme: "grid",
      styles: {
        font: "Amiri",
        halign: "center",
        fontStyle: "Bold",
      },
      cellPadding: 0,
      body: array,
      margin: { left: 5, right: 5, bottom: 0 },
      didDrawPage: function (data) {
        // Reseting top margin. The change will be reflected only after print the first page.
        data.settings.margin.top = 10;
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 10 },
        2: { cellWidth: 1 },
        3: { cellWidth: 38 },
        4: { cellWidth: 15 },
        5: { cellWidth: 16 },
        6: { cellWidth: 8 },
        7: { cellWidth: 40 },
        8: { cellWidth: 23 },
        9: { cellWidth: 40 },
      },
    });

    topMargin = doc.lastAutoTable.finalY - 73 + 2;
  });

  // Generate the table
  let header = [
    "إمضاء الولي",
    "الشهادة",
    "أدنى معدل",
    "أعلى معدل",
    "معدل الثلاثي",
  ];
  let formatedHeader = header.map((name, index) => {
    let fillColor = rgbToHex(...bulletinColors.color9);
    let textColor = rgbToHex(...bulletinColors.color2);
    let lineColor = bulletinColors.color2;
    if (index == 0 || index == 4) {
      fillColor = rgbToHex(...bulletinColors.color7);
      textColor = "#ffffff";
      lineColor = [229, 229, 229];
    }

    return {
      content: name,
      styles: {
        halign: "center",
        valign: "middle",
        fillColor: fillColor,
        textColor: textColor,
        lineColor: lineColor,
      },
    };
  });
  let arr = [];

  arr[0] = "";
  arr[1] = affichageBulletin.side.certif
    ? getCertificationNameByMoyenne(student.moyenne, certifs)
    : "";
  arr[2] = bulletinData.minMoyenne;
  arr[3] = bulletinData.maxMoyenne;
  arr[4] = student.moyenne;
  let array = [];
  array.push(formatedHeader);
  array.push(arr);
  let startYFinalTab = (doc.previousAutoTable.finalY || 40) + 5;
  doc.autoTable({
    startY: startYFinalTab, // Add margin
    body: array,
    theme: "grid",
    styles: {
      font: "Amiri",
      halign: "center",
      fontStyle: "Bold",
    },
    cellPadding: 0,
    margin: { left: 40, right: 5, bottom: 0, top: 5 },
    columnStyles: {
      0: { cellWidth: 47 },
      1: { cellWidth: 33 },
      2: { cellWidth: 28 },
      3: { cellWidth: 28 },
      4: { cellWidth: 28 },
    },
  });
  //stamp
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  text = "امضاء مدير)ة( المدرسة";

  doc.text(text, 5, startYFinalTab + 5);

  if (config.showStamp && stampImage && stampImage.src) {
    try {
      doc.addImage(stampImage, "PNG", 5, startYFinalTab - 10, 35, 35);
    } catch (e) {
      console.info("cannot print Stamp");
    }
  }
  //end stamp
};

const printBulletin = async function (
  affichageData,
  student,
  bulletinData,
  config
) {
  const { schoolDetails, selectedStudentName, settings, bulletinType } = config;
  const doc = new JsPDF();
  const ctx = doc.context2d;

  let arrayOfImages = settings.image;
  let imgData;
  for (var i = 0; i < arrayOfImages.length; i++) {
    if (settings.activeBuilding === arrayOfImages[i].db) {
      imgData = await loadImage(arrayOfImages[i].logo);
    }
    const pdf_width = doc.internal.pageSize.getWidth();
    let logoAutoWidth = getLogoWidth(imgData, 14);
    if (affichageData.headers.studentImage && student && student.photo) {
      let studentPhotoURL = settings.resourcesUrl.replace(
        "FILE_PATH",
        student.photo
      );
      let studentIMG = new Image();
      studentIMG.src = studentPhotoURL;
      try {
        doc.addImage(studentIMG, "JPEG", pdf_width / 2 - 7, 2, 16, 18);
      } catch (error) {
        console.log("cannot print School Logo");
      }
      try {
        doc.addImage(imgData, "JPEG", 28, 2, logoAutoWidth, 14);
      } catch {
        console.log("cannot print student Imagge");
      }
    } else
      try {
        doc.addImage(
          imgData,
          "JPEG",
          pdf_width / 2 - logoAutoWidth / 2,
          6,
          logoAutoWidth,
          14
        );
      } catch {
        console.log("cannot print student Imagge");
      }
  }
  //stamp
  let stamp = settings.resourcesUrl.replace("FILE_PATH", schoolDetails.stamp);
  const stampImage = new Image(30, 30);
  if (stamp) stampImage.src = stamp;
  if (stamp) {
    try {
      await waitLoadingImage(stampImage);
    } catch (e) {}
  }
  //end stamp
  if (
    affichageData.body.fuseSubjects &&
    affichageData.body.fuseSubjects === true
  )
    bulletinData = fuseSubSubjects(bulletinData);

  await drawBulletinMondial(
    doc,
    ctx,
    bulletinData,
    affichageData,
    stampImage,
    config
  );
  doc.save(`Bulletin ${bulletinType} ${selectedStudentName}.pdf`);
};
const printAllBulletin = async function (
  affichageData,
  studentsData,
  bulletinsData,
  config
) {
  const { schoolDetails, settings, selectedClassName } = config;
  const doc = new JsPDF();
  const ctx = doc.context2d;

  let arrayOfImages = settings.image;
  let imgData;
  for (var i = 0; i < arrayOfImages.length; i++) {
    if (settings.activeBuilding === arrayOfImages[i].db) {
      const logoData = await loadImage(arrayOfImages[i].logo);
      if (logoData) {
        imgData = logoData;
      }
    }
  }
  //stamp
  let stamp = settings.resourcesUrl.replace("FILE_PATH", schoolDetails.stamp);
  const stampImage = new Image(30, 30);
  if (stamp) stampImage.src = stamp;
  if (stamp) {
    try {
      await waitLoadingImage(stampImage);
    } catch (e) {}
  }
  //end stamp
  let iterations = bulletinsData.length;
  for (const bulletinData of bulletinsData) {
    const student = studentsData.find((s) => s._id == bulletinData.id);
    const pdf_width = doc.internal.pageSize.getWidth();
    let logoAutoWidth = getLogoWidth(imgData, 14);
    if (affichageData.headers.studentImage && student && student.photo) {
      let studentPhotoURL = settings.resourcesUrl.replace(
        "FILE_PATH",
        student.photo
      );
      let studentIMG = new Image();
      studentIMG.src = studentPhotoURL;
      try {
        doc.addImage(studentIMG, "JPEG", pdf_width / 2 - 7, 2, 16, 18);
      } catch (error) {}
      try {
        doc.addImage(imgData, "JPEG", 28, 2, logoAutoWidth, 14);
      } catch {
        console.log("cannot print student Imagge");
      }
    } else
      try {
        doc.addImage(
          imgData,
          "JPEG",
          pdf_width / 2 - logoAutoWidth / 2,
          6,
          logoAutoWidth,
          14
        );
      } catch {
        console.log("cannot print student Imagge");
      }
    if (
      affichageData.body.fuseSubjects &&
      affichageData.body.fuseSubjects === true
    )
      bulletinData = fuseSubSubjects(bulletinData);

    await drawBulletinMondial(
      doc,
      ctx,
      bulletinData,
      affichageData,
      stampImage,
      config
    );
    if (--iterations) doc.addPage();
  }

  doc.save(`Bulletin ${selectedClassName}.pdf`);
};

export default {
  printBulletin,
  printAllBulletin,
};
